export const SYSTEM_MESSAGES = {
    IMPORT_SUCCESS: 'Owners data was successfully imported to the app',
    IMPORT_FAILED: 'Unexpected error occurred during importing owners. Please, try again later',
};

export const SNACK_TIMEOUT = 5000;
export const DEBOUNCE = 400;